import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { appValidator } from "../Validation";

const rules = {
    zipCode: ['required', 'regex:/^\\d{5}$/', 'valid_zip']
};

export const customErrorMessages = {
    required: "Please enter a 5-digit ZIP code",
    regex: "Please enter a 5-digit ZIP code"
};

//export const allFieldsValidation = (data) => {
//    return allFieldsValidationCommon(data, rules, customErrorMessages);
//};

export const allFieldsValidation = (data) => {
    return appValidator.validate(data, rules, customErrorMessages);
};